var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55843 3.48367H5.62854C5.91099 3.48367 6.14023 3.70822 6.14023 3.98491C6.14023 4.2616 5.91099 4.48616 5.62854 4.48616H2.55843C2.27598 4.48616 2.04674 4.2616 2.04674 3.98491C2.04674 3.70822 2.27598 3.48367 2.55843 3.48367ZM9.84995 9.14424C10.05 9.33972 10.05 9.65752 9.84995 9.85301C9.64988 10.049 9.32598 10.049 9.12642 9.85301L7.04233 7.87308L7.76585 7.16432L9.84995 9.14424ZM4.09348 7.01745C2.40083 7.01745 1.02337 5.6686 1.02337 4.00998C1.02337 2.35185 2.40083 1.00249 4.09348 1.00249C5.78614 1.00249 7.1636 2.35185 7.1636 4.00998C7.1636 5.6686 5.78614 7.01745 4.09348 7.01745ZM4.09348 0C1.83286 0 0 1.79547 0 4.00998C0 6.22499 1.83286 8.01994 4.09348 8.01994C6.35411 8.01994 8.18697 6.22499 8.18697 4.00998C8.18697 1.79547 6.35411 0 4.09348 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/zoom_out_icon.092dd1ed505ed9d090ab4c8aaf14e4fd.svg";
export { ForwardRef as ReactComponent };